// extracted by mini-css-extract-plugin
export default {"row":"dzxLZF","premiumLabel":"wldDl1","emptyStateSubtitle":"jad5tw","heading":"QJd_3H"};